import { ArticleHeading2, ArticleHeading4, ArticleParagraph1, Image } from '@cian/ui-kit';
import * as React from 'react';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../constants/mediaQueries';
import { DealSalePromoChip } from '../DealSalePromoChip';
import { TDealCard } from '../../containers/DealStepsSectionContainer/content';

import * as styles from './styles.css';

export interface IDealStepCardProps extends TDealCard {
  onLearnMoreClick(): void;
}

/**
 * Карточка в секции "Лёгкий путь к сделке за 3 шага".
 */
export const DealStepCardDesktop: React.FC<IDealStepCardProps> = props => {
  return (
    <li className={styles['card']}>
      <Image
        src={props.imageX1}
        sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: props.imageX2 }, { srcset: props.imageX1 }]}
        width={140}
        height={100}
        loading="lazy"
      />
      <div className={styles['chip']}>
        <DealSalePromoChip>{props.chip}</DealSalePromoChip>
      </div>
      <ArticleHeading2 as="h3">
        <span className={styles['title']}>{props.title}</span>
      </ArticleHeading2>
      <div className={styles['description']}>
        <ArticleParagraph1 color="gray60_100">{props.description}</ArticleParagraph1>
      </div>
      <button className={styles['learn-more']} onClick={props.onLearnMoreClick}>
        <ArticleHeading4 color="primary_100">Узнать больше</ArticleHeading4>
      </button>
    </li>
  );
};
